import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { formatNaira } from '../../utils/format';
interface StepNavigationProps {
  step: number;
  totalSteps: number;
  estimateTotal: number | null;
  onBack: () => void;
  onNext: () => void;
}
export function StepNavigation({
  step,
  totalSteps,
  estimateTotal,
  onBack,
  onNext
}: StepNavigationProps) {
  return <div className="mt-10 flex items-center justify-between gap-4 border-t border-forest-700/10 pt-6" data-id="element-248" data-mp="1dnluhu54thtw">
      {step > 1 ? <button type="button" onClick={onBack} className="inline-flex items-center gap-2 rounded-full px-4 py-3 text-sm text-forest-700 transition-colors duration-150 ease-premium hover:bg-ivory-200" data-id="element-249" data-mp="18o8xigkjqudl">
          <ArrowLeftIcon size={15} aria-hidden="true" data-id="element-250" data-mp="yyfn3iw54lax" />
          Back
        </button> : <span data-id="element-251" data-mp="1wfebsrau9els" />}

      <div className="flex items-center gap-4" data-id="element-252" data-mp="1wfxyelbfor65">
        {estimateTotal !== null && <p className="text-right lg:hidden" data-id="element-253" data-mp="1rla5895hj8l8">
            <span className="block text-[10px] uppercase tracking-overline text-gold-700" data-id="element-254" data-mp="3j7uukwm0mxw2">Estimate</span>
            <span className="font-display text-lg text-forest-700" data-id="element-255" data-mp="3o662v2wnx0c6">{formatNaira(estimateTotal)}</span>
          </p>}
        {step < totalSteps && <button type="button" onClick={onNext} className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-forest-700 px-7 py-3.5 text-sm text-ivory-100 transition-colors duration-150 ease-premium hover:bg-forest-600 active:scale-[0.98]" data-id="element-256" data-mp="3ehegdaadf88n">
            {step === totalSteps - 1 ? 'Continue to submit' : 'Continue'}
            <ArrowRightIcon size={15} className="transition-transform duration-200 ease-premium group-hover:translate-x-1" aria-hidden="true" data-id="element-257" data-mp="2qljwptpsnb2y" />
          </button>}
      </div>
    </div>;
}